const StartIcon = props => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M24.4998 4.71607L20.8598 13.4049L16.4848 23.9049C16.4173 24.0644 16.3039 24.2003 16.159 24.2954C16.0141 24.3904 15.8443 24.4402 15.6711 24.4387C15.5563 24.4416 15.4424 24.4176 15.3386 24.3687C15.1236 24.2797 14.9529 24.1087 14.8642 23.8937C14.7756 23.6786 14.7763 23.4371 14.8661 23.2224L18.7161 13.9999H4.32219C4.13917 13.9979 3.96134 13.9387 3.81387 13.8303C3.66631 13.722 3.55639 13.5702 3.49969 13.3962C3.43607 13.2315 3.42376 13.0515 3.46442 12.8797C3.50498 12.7079 3.59658 12.5525 3.7272 12.4337L8.1722 8.36482L5.5472 4.86482C5.42734 4.68754 5.37666 4.47254 5.40464 4.26034C5.43262 4.04815 5.53735 3.85365 5.69904 3.71355C5.86073 3.57337 6.06817 3.49735 6.28219 3.49981H23.6772C23.9699 3.50136 24.2425 3.64911 24.4034 3.89356C24.5714 4.13427 24.6076 4.44309 24.4997 4.71606L24.4998 4.71607Z" />
  </svg>
)

export default StartIcon
